var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-main",style:({'top': _vm.top + 'px'}),on:{"click":function($event){$event.stopPropagation();return _vm.backMain($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }